export default "__VITE_PUBLIC_ASSET__c9a58ca4__"